<template>
  <div class="body-content home-page">
    <div class="page-loader" v-show="pageLoading">
      <clip-loader
        :loading="pageLoading"
        :color="color"
        :size="size"
      ></clip-loader>
    </div>
    <div class="row">
      <div class="left-content col-xl-3 col-12">
        <div class="home-banner">
          <!--div class="d-xl-none">
            <div
              class="d-flex align-items-center justify-content-end py-3 px-3"
            >
              <div
                class="follow-fb-mb d-flex align-items-center justify-content-end py-2 px-2"
              >
                <div><span class="font-16 mx-3">Follow us on</span></div>
                <div class="testd">
                  <a href="#" target="_blank"
                    ><img src="@/img/social/fb.png"
                  /></a>
                </div>
              </div>
            </div>
          </div-->
          <div class="arrow-scroll-btm text-center m-auto d-md-none">
            <a href="#rightcontent"><img src="@/img/arrow_scroll_btm.png" /></a>
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-12">
        <div class="right-content py-md-5 px-md-5 px-xl-0" id="rightcontent">
          <!--div class="d-none d-xl-block">
            <div
              class="d-flex align-items-center justify-content-end my-4 mx-5"
            >
              <div><span class="font-14 me-3">Follow us on</span></div>
              <div>
                <a href="#" target="_blank"
                  ><img src="@/img/social/fb.png" width="24px"
                /></a>
              </div>
            </div>
          </div-->
          <div id="product-sec">
            <ProductSlick v-bind:products="products" v-bind:cart="cart" />
          </div>
          
          <div class="divider mx-5"></div>
          <div class="pb-5 px-5 mx-xl-5">
            <p class="why-choose fw-bold">Why Choose Us?</p>            
            <p class="font-16">
              Herbalicious2u specializes in helping you to conveniently pick the
              perfect, heart-warming gift sets for your loved ones. Hand-picked
              with our customer’s best interest in mind, our products aim to
              help our shoppers fill their needs to provide their bodies inside
              and out, with nutrients that nourish their health. Our gift sets
              are crafted with love and care and we have goodies ranging from
              delicious freeze-dried fruits and vegetables to refreshing,
              nutritious tea. There is always something relevant for everyone!
            </p>
          </div>
          <div
            class="accordion product-accordion px-5"
            id="accordionEProductAction"
          >
            <div class="accordion-item shipping-address py-4" id="shipping-sec">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button collapsed px-xl-5 px-0"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                >
                  Shipping Address
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse"
                aria-labelledby="headingOne"
                data-bs-parent="#accordionEProductAction"
              >
                <div class="accordion-body px-xl-5 px-0">
                  <p class="font-14 pb-4">
                    <span class="text-theme-5">*</span> Required field
                  </p>
                  <form>
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label for="recipientname" class="form-label"
                          >Recipient Name
                          <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="recipientname"
                          v-model="shippingDetails.first_name"
                          @input="restrictInput"
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label for="email" class="form-label"
                          >Email <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          v-model="shippingDetails.email"
                        />
                        <div
                          class="
                            form-text
                            font-12
                            fst-italic
                            text-xl-end text-center
                            pt-2
                          "
                        >
                          Invoice & delivery details will be sent to following
                          email.
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <label for="contact" class="form-label"
                          >Contact <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="tel"
                          class="form-control"
                          id="contact"
                          v-model="shippingDetails.phone"
                          @input="restrictInput"
                        />
                        <div
                          class="
                            form-text
                            font-12
                            fst-italic
                            text-xl-end text-center
                            pt-2
                          "
                        >
                          Delivery notification may send through yours sms.
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <label for="address1" class="form-label"
                          >Address Line 1
                          <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="address1"
                          v-model="shippingDetails.address_1"
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label for="address2" class="form-label"
                          >Address Line 2 (Optional)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="address2"
                          v-model="shippingDetails.address_2"
                        />
                      </div>
                      <div class="col-lg-6 col-12 mb-3">
                        <label for="city" class="form-label"
                          >City <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="city"
                          v-model="shippingDetails.city"
                          @input="restrictInput"
                        />
                      </div>
                      <div class="col-lg-6 col-12 mb-3">
                        <label for="zipcode" class="form-label"
                          >Zip Code <span class="text-theme-5">*</span></label
                        >
                        <input
                          type="int"
                          class="form-control"
                          id="zipcode"
                          maxlength="5"
                          v-model="shippingDetails.postcode"
                          @input="restrictInput"
                        />
                      </div>
                      <div class="col-lg-6 col-12 mb-3">
                        <label for="country" class="form-label"
                          >Country <span class="text-theme-5">*</span></label
                        >
                        <select
                          id="country"
                          class="form-select form-control"
                          v-model="shippingDetails.country"
                        >
                          <option value="MY">Malaysia</option>
                        </select>
                      </div>
                      <div class="col-lg-6 col-12 mb-3">
                        <label for="state" class="form-label"
                          >State <span class="text-theme-5">*</span></label
                        >
                        <select
                          id="state"
                          class="form-select form-control"
                          v-model="shippingDetails.state"
                        >
                          <option value="JHR">Johor</option>
                          <option value="KDH">Kedah</option>
                          <option value="KTN">Kelantan</option>
                          <option value="KUL">Kuala Lumpur</option>
                          <option value="MLK">Malacca</option>
                          <option value="NSN">Negeri Sembilan</option>
                          <option value="PHG">Pahang</option>
                          <option value="PNG">Penang</option>
                          <option value="PRK">Perak</option>
                          <option value="PLS">Perlis</option>
                          <option value="PJY">Putrajaya</option>
                          <option value="SGR">Selangor</option>
                          <option value="SWK">Sarawak</option>
                          <option value="SBH">Sabah</option>
                          <option value="TRG">Terengganu</option>
                        </select>
                      </div>
                      <!-- <div class="col-lg-6 col-12 mb-3">
                        <label for="delivery-date" class="form-label"
                          >Delivery Date <span class="text-theme-5">*</span></label
                        >
                        <input
                          id="delivery-date"
                          class="form-control"
                          type="date"
                          :value="deliveryDate"
                          v-on:input="updateValue('deliveryDate', $event.target.value)"
                          :min="minDate"
                          :max="maxDate"
                        >
                      </div> -->
                      <div class="col-12 mb-3">
                        <label for="remark" class="form-label">Remark</label>
                        <textarea
                          class="form-control"
                          id="remark"
                          rows="4"
                          placeholder="Please put your greeting message here"
                          v-model="shippingDetails.remark"
                          maxlength="100"
                        ></textarea>
                      </div>
                      <!-- <div class="col-12 mt-2 mb-4">
                        <div class="form-check" id="send-gift-checkbox">
                          <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" v-model="giftChecked" @click="checkGift()">
                          <label class="form-check-label ms-3" for="flexCheckChecked">
                            Send this as a gift
                          </label>
                        </div>
                      </div> -->
                      <!-- <div class="mb-1" id="send-gift-content" v-show="giftChecked">
                        <div class="col-12 mb-3">
                          <label for="give-message" class="form-label">Gift Message</label>
                          <textarea
                            class="form-control"
                            id="give-message"
                            rows="4"
                            maxlength="100"
                            :value="greetingMessage"
                            v-on:input="updateValue('greetingMessage', $event.target.value)"
                          ></textarea>
                        </div>
                        <div class="col-12 mb-3">
                          <label for="sender-name" class="form-label">Sender's Name</label>
                          <input
                            class="form-control"
                            id="sender-name"
                            :value="senderName"
                            v-on:input="updateValue('senderName', $event.target.value)"
                          >
                          <span class="font-16 text-theme-6" v-if="!senderNameValid">{{ senderNameMsg }}</span>
                        </div>
                      </div> -->
                      <div class="mt-4 mb-5">
                        <button
                          class="btn bg-theme-1 py-3 px-5"
                          @click.prevent="submitShipping"
                        >
                          <span class="font-16 fw-bold text-white"
                            >Continue</span
                          >
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="accordion-item review-order py-4" id="review-sec">
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed px-xl-5 px-0"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                >
                  Review Order
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#accordionEProductAction"
              >
                <div
                  class="accordion-body px-xl-5 px-0"
                  v-if="orderSummary.products && orderSummary.products.length"
                >
                  <div
                    class="cart-product"
                    v-for="(item, index) in orderSummary.products"
                    :key="index"
                  >
                    <div class="d-flex pt-2">
                      <div
                        class="cart-product-img"
                        :style="{
                          background:
                            'url(' +
                            (item.images && item.images.length > 0
                              ? item.images[0]
                              : '') +
                            ')',
                        }"
                      ></div>
                      <div class="w-100 ms-3">
                        <div>
                          <span
                            class="
                              cart-product-no
                              font-16
                              fw-bold
                              text-white
                              bg-theme-4
                              py-1
                              px-4
                            "
                            >{{ item.quantity }}x</span
                          >
                        </div>
                        <div class="pt-2">
                          <span class="font-16"> {{ item.name }} </span>
                        </div>
                        <div
                          class="cart-product-variations"
                          v-show="item.selections.length > 0"
                        >
                          <ul>
                            <li
                              v-for="(selection, sindex) in item.selections"
                              :key="sindex"
                              v-html="selection.selected_option"
                            ></li>
                          </ul>
                        </div>
                        <p class="font-16 text-md-end pt-md-0 pt-2">
                          {{ products.currency_symbol
                          }}{{ Number(item.subtotal) | currencyFormat }}
                        </p>
                        <p
                          class="font-16 fw-bold text-theme-3"
                          v-show="item.stock_left"
                        >
                          {{ item.stock_left }} item left
                        </p>
                      </div>
                    </div>
                    <div class="review-order-divider"></div>
                  </div>
                  <div
                    class="
                      subtotal-shipping-price
                      d-flex
                      align-items-start
                      justify-content-between
                      flex-md-row flex-column
                      pt-2
                    "
                  >
                    <div
                      v-if="promofunction"
                      class="
                        promo-code
                        d-flex
                        align-items-md-start align-items-end
                        flex-column
                      "
                      :class="promoActive ? 'active' : ''"
                    >
                      <div
                        class="
                          promo-code-input
                          d-flex
                          align-items-center
                          justify-content-between
                          py-3
                          px-4
                          mb-3
                        "
                      >
                        <div>
                          <input
                            type="text"
                            id="promo-text"
                            name="promo"
                            class="font-16 text-uppercase fw-bold me-3"
                            placeholder="PROMO CODE"
                            maxlength="15"
                            v-model.trim="promocode"
                          />
                        </div>
                        <div id="apply-code">
                          <span
                            class="font-16 text-uppercase text-theme-6 fw-bold"
                            v-if="promoProcess"
                            >Processing</span
                          >
                          <span
                            class="font-16 text-uppercase text-theme-7 fw-bold"
                            v-else
                            @click="applyPromoCode()"
                            >APPLY</span
                          >
                        </div>
                        <div id="remove-code">
                          <span
                            class="font-16 text-uppercase text-theme-6 fw-bold"
                            v-if="promoProcess"
                            >Processing</span
                          >
                          <span
                            class="font-16 text-uppercase text-theme-6 fw-bold"
                            v-else
                            @click="removePromoCode()"
                            >REMOVE</span
                          >
                        </div>
                      </div>
                      <div id="code-applied-text">
                        <div class="d-flex align-items-center">
                          <img
                            src="@/img/tick.png"
                            alt="tick"
                            width="18px"
                            class="me-2"
                            v-if="promoValid"
                          />
                          <span
                            class="font-16 text-theme-7"
                            v-if="!promoProcess && promoValid"
                            >Promo Code Applied!</span
                          >
                          <span
                            class="font-16 text-theme-6"
                            v-if="!promoProcess && !promoValid"
                            >{{ promoCodeMsg }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="
                        d-flex
                        align-items-end
                        justify-content-end
                        flex-column
                        w-100
                        pt-md-0 pt-4
                      "
                    >
                      <div
                        class="
                          subtotal-price
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div><p class="font-20">Subtotal</p></div>
                        <div>
                          <p class="font-20">
                            {{ products.currency_symbol }}
                            {{
                              Number(orderSummary.total_cart_amount)
                                | currencyFormat
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="
                          shipping-price
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div><p class="font-20">Shipping</p></div>
                        <div>
                          <p class="font-20" v-if="updatedShipping">
                            {{ products.currency_symbol }}
                            {{
                              Number(orderSummary.total_shipping_amount)
                                | currencyFormat
                            }}
                          </p>
                          <p class="font-16 fst-italic" v-else>
                            Calculated at next step
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="promofunction"
                        class="
                          discount-price
                          d-flex
                          align-items-center
                          justify-content-between
                          text-theme-6
                        "
                        :class="promoValid ? '' : 'd-none'"
                      >
                        <div><p class="font-20 fw-bold">Discount</p></div>
                        <div class="d-flex align-items-center">
                          <p class="font-20 fw-bold me-2">- RM</p>
                          <p class="font-20 fw-bold">
                            {{ orderSummary.discount_amount }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="review-order-divider"></div>
                  <div>
                    <div
                      class="
                        d-flex
                        align-items-end
                        justify-content-end
                        flex-column
                      "
                    >
                      <div
                        class="
                          total-price
                          d-flex
                          align-items-center
                          justify-content-between
                        "
                      >
                        <div><p class="font-20 fw-bold">Total</p></div>
                        <div>
                          <p class="font-20 fw-bold">
                            {{ products.currency_symbol }}
                            {{
                              Number(orderSummary.total_amount) | currencyFormat
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="review-order-divider"></div>
                    <p class="font-14 pt-3 pb-4">
                      By placing order, I agree to the Innity's
                      <a href="" data-bs-toggle="modal" data-bs-target="#tnc"
                        >Terms and Conditions</a
                      >,
                      <a
                        href=""
                        data-bs-toggle="modal"
                        data-bs-target="#privacy"
                        >Privacy Policy</a
                      >,
                      <a
                        href=""
                        data-bs-toggle="modal"
                        data-bs-target="#shipping-policy"
                        >Shipping Policy</a
                      >
                      and
                      <a
                        href=""
                        data-bs-toggle="modal"
                        data-bs-target="#refund-policy"
                        >Refund Policy</a
                      >.
                    </p>
                  </div>
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      flex-md-row flex-column
                      mb-5
                    "
                  >
                    <button
                      class="btn btn-green-border bg-white py-3 px-5 mb-4"
                      @click.prevent="showCartModal"
                    >
                      <span class="font-16 fw-bold text-theme-1"
                        >Return to Cart</span
                      >
                    </button>
                    <button
                      class="btn bg-theme-1 py-3 px-5 mb-md-4 place_order_btn"
                      v-on:click="submitOrder"
                    >
                      <span class="font-16 fw-bold text-white place_order_btn"
                        >Place Order Now</span
                      >
                    </button>
                  </div>
                </div>
                <div class="accordion-body px-xl-5 px-0" v-else>
                  <p class="font-16 text-center fst-italic">
                    <a
                      href="javascript:void(0)"
                      @click.prevent="showCartModal"
                      style="text-decoration: none"
                      >Click
                      <span style="border-bottom: 1px solid #000">HERE</span> to
                      checkout</a
                    >
                  </p>
                </div>
              </div>
            </div>

            <form
              ref="form"
              :action="paymentUrl"
              method="post"
              style="display: none"
            >
              <input name="OrderID" v-model="this.order.order_id" />
              <input name="Vendor" v-model="this.vendor" />
              <input
                name="Amount"
                type="hidden"
                v-model="this.order.total_amount"
                readonly
              />
              <input name="CartType" type="hidden" value="single" />
              <input name="Currency" type="hidden" v-model="this.currency" />
              <input
                name="UserName"
                v-model="this.shippingDetails.first_name"
              />
              <input name="UserEmail" v-model="this.shippingDetails.email" />
              <input name="UserContact" v-model="this.shippingDetails.phone" />
              <input name="Remark" v-model="this.shippingDetails.remark" />
            </form>
          </div>
          <div class="footer font-14 pt-5 pb-xl-0 pb-md-5 mx-xl-5">
            <div
              class="
                d-flex
                align-items-start
                justify-content-between
                flex-md-row flex-column
                px-5
                mx-md-5
              "
            >
              <div
                class="
                  company-customercare
                  d-flex
                  align-items-start
                  justify-content-between
                  pb-md-0 pb-4
                "
              >
                <div>
                  <p class="font-12 fw-bold">Company</p>
                  <div class="pb-3">
                    <a
                      href="https://moments.passionation.co/"
                      target="_blank"
                      class="footer-menu-link"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">Moments Homepage</span>
                      </div>
                    </a>
                  </div>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#about-moments"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">About Moments</span>
                      </div>
                    </a>
                  </div>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#tnc"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">Terms and Conditions</span>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="customercare-mb d-md-none">
                  <p class="font-12 fw-bold">Customer Care</p>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#faq"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">FAQ</span>
                      </div>
                    </a>
                  </div>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#shipping-policy"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">Shipping Policy</span>
                      </div>
                    </a>
                  </div>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#refund-policy"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">Refund Policy</span>
                      </div>
                    </a>
                  </div>
                  <div class="pb-3">
                    <a
                      href=""
                      class="footer-menu-link"
                      data-bs-toggle="modal"
                      data-bs-target="#privacy"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          src="@/img/footer_arrow.png"
                          alt="footer arrow"
                          class="img-fluid me-3"
                          width="10px"
                        />
                        <span class="font-12">Privacy Policy </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="customercare d-none d-md-block">
                <p class="font-12 fw-bold">Customer Care</p>
                <div class="pb-3">
                  <a
                    href=""
                    class="footer-menu-link"
                    data-bs-toggle="modal"
                    data-bs-target="#faq"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="@/img/footer_arrow.png"
                        alt="footer arrow"
                        class="img-fluid me-3"
                        width="10px"
                      />
                      <span class="font-12">FAQ</span>
                    </div>
                  </a>
                </div>
                <div class="pb-3">
                  <a
                    href=""
                    class="footer-menu-link"
                    data-bs-toggle="modal"
                    data-bs-target="#shipping-policy"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="@/img/footer_arrow.png"
                        alt="footer arrow"
                        class="img-fluid me-3"
                        width="10px"
                      />
                      <span class="font-12">Shipping Policy</span>
                    </div>
                  </a>
                </div>
                <div class="pb-3">
                  <a
                    href=""
                    class="footer-menu-link"
                    data-bs-toggle="modal"
                    data-bs-target="#refund-policy"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="@/img/footer_arrow.png"
                        alt="footer arrow"
                        class="img-fluid me-3"
                        width="10px"
                      />
                      <span class="font-12">Refund Policy</span>
                    </div>
                  </a>
                </div>
                <div class="pb-3">
                  <a
                    href=""
                    class="footer-menu-link"
                    data-bs-toggle="modal"
                    data-bs-target="#privacy"
                  >
                    <div class="d-flex align-items-center">
                      <img
                        src="@/img/footer_arrow.png"
                        alt="footer arrow"
                        class="img-fluid me-3"
                        width="10px"
                      />
                      <span class="font-12">Privacy Policy </span>
                    </div>
                  </a>
                </div>
              </div>
              <div class="contact-us">
                <p class="font-12 fw-bold">Contact Us</p>
                <div class="pb-md-0 pb-1">
                  <p class="font-12">
                    Email:
                    <a v-bind:href="'mailto:' + mailtourl">{{ mailtourl }}</a>
                  </p>
                </div>
                <div class="pb-4">
                  <p class="font-12">Tel: +60 3 7880 5611</p>
                </div>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-md-start justify-content-between
                    pt-md-2 pt-4
                  "
                >
                  <div><span class="font-12 fw-bold">Follow Us</span></div>
                  <div class="ms-2">
                    <a
                      href="https://web.facebook.com/moments.passionation?_rdc=1&_rdr"
                      target="_blank"
                      ><img
                        src="@/img/social/fb_footer.png"
                        alt="fb footer"
                        class="img-fluid mx-4"
                        width="22px"
                    /></a>
                    <a
                      href="https://www.instagram.com/moments.passionation/"
                      target="_blank"
                      ><img
                        src="@/img/social/ig_footer.png"
                        alt="ig footer"
                        class="img-fluid"
                        width="21px"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-divider mx-md-0 mx-5"></div>
            <div class="text-center pb-md-4 px-5 mx-md-5">
              <div
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  flex-md-row flex-column
                "
              >
                <div class="me-md-2">
                  <span class="font-12"
                    >Copyright © 2022 Moments by Passionation.co.</span
                  >
                </div>
                <div>
                  <span class="font-12"
                    >All Rights Reserved by Innity Sdn Bhd (199901025800).</span
                  >
                </div>
              </div>
              <div>
                <span class="font-12"
                  >Passionation.co is a trademark of Innity Sdn Bhd and its
                  affiliates.</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSlick from "./ProductSlick.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  name: "MainContent",
  props: [
    "products",
    "cart",
    "orderSummary",
    // "cartSubTotal",
    "shippingDetails",
    "updatedShipping",
    "shippingCollapse",
    "reviewCollapse",
    "pageLoading",
    "promoCode",
    "promoProcessing",
    "responseMessages",
    "responsePromocode",
    "greetingMessage",
    "senderName",
    "giftMsgCheck",
    "deliveryDate",
    "currency",
    "vendorName",
    "appId",
  ],
  components: {
    ProductSlick,
    ClipLoader,
  },
  data() {
    return {
      paymentUrl: process.env.VUE_APP_PAY_URL,
      promofunction: process.env.VUE_APP_PROMO == "true" ? true : false,
      shipping: this.shippingDetails,
      order: this.orderSummary,
      fakeamount: 1.0,
      vendor: process.env.VUE_APP_VENDOR,
      color: "#ffffff",
      size: "50px",
      mailtourl: "ecom.sales@passionation.co",
      promocode: this.promoCode,
      promoProcess: this.promoProcessing,
      promoActive: false,
      promoValid: false,
      senderNameValid: true,
      promoCodeMsg: "Promo Code Invalid!",
      senderNameMsg: "Sender Name Invalid!",
      resMessages: this.responseMessages,
      giftChecked: this.giftMsgCheck,
      minDate: new Date(
        new Date(new Date().getTime() + 4 * 24 * 60 * 60 * 1000)
      ),
      maxDate: new Date(
        new Date(new Date().getTime() + 29 * 24 * 60 * 60 * 1000)
      ),
    };
  },
  filters: {
    currencyFormat: function (value) {
      let val = value.toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    restrictInput() {
      this.shippingDetails.first_name = this.shippingDetails.first_name.replace(
        /[0-9]/g,
        ""
      );
      this.shippingDetails.city = this.shippingDetails.city.replace(
        /[0-9]/g,
        ""
      );

      this.shippingDetails.phone = this.shippingDetails.phone.replace(
        /[^0-9]/g,
        ""
      );

       this.shippingDetails.postcode = this.shippingDetails.postcode.replace(
        /[^0-9]/g,
        ""
      );
    },
    showCartModal: function () {
      this.$parent.showCartModal();
    },
    submitShipping: function () {
      this.$parent.updateShipping();
    },
    submitOrder: function () {
      let submitForm = this.$refs.form;
      this.$parent.checkout(submitForm);
      // this.$refs.form.submit()
    },
    applyPromoCode: function () {
      if (this.promocode != "") {
        this.promoActive = true;
        this.$parent.applyPromoCode(this.promocode);
      }
    },
    removePromoCode: function () {
      this.promocode = "";
      this.promoActive = false;
      this.$parent.applyPromoCode(this.promocode);
    },
    checkGift: function () {
      this.giftChecked = !this.giftChecked;
      this.$parent.updateValue("giftMsgCheck", this.giftChecked);
    },
    updateValue: function (variable, value) {
      this.$parent.updateValue(variable, value);
    },
  },
  watch: {
    orderSummary(val) {
      this.order = val;

      if (val.discount_amount == 0 && val.free_shipping == false) {
        this.promoValid = false;
      } else {
        this.promoValid = true;
      }
    },
    shippingDetails(val) {
      this.shipping = val;
    },
    promoCode(val) {
      this.promocode = val;
      if (val != "") {
        this.promoActive = true;
      }
    },
    promoProcessing(val) {
      this.promoProcess = val;
    },

    responseMessages(val) {
      this.resMessages = val;

      if (this.resMessages.promocode) {
        this.promoValid = false;
        this.promoCodeMsg = this.resMessages.promocode;
      } else {
        this.promoCodeMsg = "Promo Code Invalid!";
      }

      if (this.resMessages.sender_name) {
        this.senderNameValid = false;
        this.senderNameMsg = this.resMessages.sender_name;
      } else {
        this.senderNameValid = true;
      }
    },
    giftMsgCheck(val) {
      this.giftChecked = val;
    },
  },

  mounted() {
    //conver date to yyyy-mm-dd
    let min_date = new Date(this.minDate);
    var min_year = min_date.getFullYear();
    var min_month = ("0" + (min_date.getMonth() + 1)).slice(-2);
    var min_day = ("0" + min_date.getDate()).slice(-2);
    this.minDate = min_year + "-" + min_month + "-" + min_day;

    let max_date = new Date(this.maxDate);
    var max_year = max_date.getFullYear();
    var max_month = ("0" + (max_date.getMonth() + 1)).slice(-2);
    var max_day = ("0" + max_date.getDate()).slice(-2);
    this.maxDate = max_year + "-" + max_month + "-" + max_day;
  },
};
</script>

<style scoped>
/* .v-spinner {
  display: inline-block;
  margin-left: 5px;
  vertical-align: inherit;
} */
.page-loader {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.7;
  z-index: 1000;
}
.page-loader .v-spinner {
  top: 50%;
  position: relative;
}
</style>
